import { render } from "./ModalMensagemWs.vue?vue&type=template&id=5ae4b762"
import script from "./ModalMensagemWs.vue?vue&type=script&lang=js"
export * from "./ModalMensagemWs.vue?vue&type=script&lang=js"

import "./ModalMensagemWs.vue?vue&type=style&index=0&id=5ae4b762&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\apontamentowebvueV3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__